const connectWebSocket = (domain) => {
  const ws = new WebSocket(`wss://${import.meta.env.VITE_WEB_SOCKET}/?id=${domain}`);
  ws.onerror = function (err) {
    console.error(err);
    ws.close();
  };
  heartbeat(ws);
  return ws;
};

const heartbeat = (socket) => {
  if (!socket || socket.readyState !== 1) return;
  socket.send('heartbeat');
  setTimeout(heartbeat(socket), 500);
};

const ID = function () {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return '_' + Math.random().toString(36).substr(2, 9);
};

export default class NewWebSocket {
  listens = {}
  connection = null

  connect(domain) {
    this.connection = connectWebSocket(domain);
    this.bindEvents(domain);
  }

  bindEvents(domain) {
    this.connection.onclose = (e) => {
      setTimeout(() => {
        this.connection = connectWebSocket(domain);
        this.bindEvents(domain);
      }, 1000);
    };
    this.connection.onmessage = (event) => {
      try {
        if (event) {
          const data = JSON.parse(event.data);
          for (const key in this.listens) {
            if (Object.hasOwnProperty.call(this.listens, key)) {
              const listen = this.listens[key];
              if (data.Type == listen.key) {
                if (listen.callback) {
                  listen.callback(data.Data);
                }
              }
            }
          }
        }
      } catch (e) {
        throw e;
      }
    };
  }

  send(data) {
    this.connection.send(JSON.stringify(data));
  }

  onmessage(key, callback) {
    const id = ID();
    this.listens[id] = {
      key,
      callback,
    };
    return () => {
      delete this.listens[id];
    };
  }
  offmessage(key) {
    Object.keys(this.listens).forEach(id => {
      if (this.listens[id]["key"] == key) {
        delete this.listens[id];
      }
    })
  }
}
